import { Injectable } from "@angular/core";
import { NdmsSafeSubscriber } from 'projects/shared/core/interfaces/ndms-safe-subscriber';
import { LookupService } from 'projects/shared/core/services/lookup.service';
import { ResponderAirportModel } from 'projects/rms/app/api/models/responder-airport-model';
import { ResponderAirportService } from 'projects/rms/app/api/services/responder-airport.service';
import { AirportService } from 'projects/rms/app/api/services/airport.service';
import { StateNameService } from 'projects/rms/app/api/services/state-name.service';
import { StateNameModel } from 'projects/rms/app/api/models/state-name-model';
import { FindFilter } from 'projects/rms/app/api/models/find-filter';

@Injectable({
  providedIn: "root"
})
export class ResponderProfileAirportsService extends NdmsSafeSubscriber {

  constructor(
    private _airportService: AirportService,
    private _stateNameService: StateNameService,
    private _responderAirportService: ResponderAirportService,
    private lookupService: LookupService) {
    super();
  }

  loadResponderAirports(responderId: number) {
    return new Promise((resolve, reject) => {
      const filter: FindFilter = {
        findKeys: {
          "ResponderId": responderId.toString()
        },
        includes: ["Airport"],
        pagingInfo: {
          "pageNumber": 0,
          "pageSize": 100
        },
        sortInfos: [{ "columnName": "DisplayOrder", "isDescending": false }]
      };
      this.safeSubscribe(this._responderAirportService.FindInDomain(filter),
        data => {
          resolve(data);
        },
        error => reject(error));
    });
  }

  loadLookups() {
    return new Promise<void>((resolve, reject) => {
      this.safeSubscribe(this._airportService.Lookups(), (data) => {
        this.lookupService.loadLookups(data);
        resolve();
      }, response => reject(response));
    });
  }

  loadStates() {
    return new Promise<StateNameModel[]>((resolve, reject) => {
      const filter: FindFilter = {
        findKeys: {},
        includes: [],
        pagingInfo: {
          "pageNumber": 0,
          "pageSize": 200
        },
        sortInfos: [{ "columnName": "Name", "isDescending": false }]
      };
      this.safeSubscribe(this._stateNameService.FindInDomain(filter), data => {
        resolve(data);
      },
      error => reject(error));
    });
  }

  addResponderAirport(responderAirport: ResponderAirportModel) {
    return new Promise((resolve, reject) => {
      this.safeSubscribe(this._responderAirportService.Add(responderAirport),
        data => {
          if (data.DomainExecutionErrors) {
            reject({ modelErrors: data.DomainExecutionErrors });
          } else {
            resolve(data);
          }
        },
        response => reject(response));
    });
  }

  updateResponderAirport(responderAirport: ResponderAirportModel) {
    return new Promise<void>((resolve, reject) => {
      this.safeSubscribe(this._responderAirportService.Update(responderAirport),
        data => {
          if (data.DomainExecutionErrors) {
            reject({ modelErrors: data.DomainExecutionErrors });
          } else {
            resolve(data);
          }
        },
        response => reject(response));
    });
  }

  deleteResponderAirport(responderAirport: ResponderAirportModel) {
    return new Promise<void>((resolve, reject) => {
      this.safeSubscribe(this._responderAirportService.Delete(responderAirport),
        data => {
          if (data.DomainExecutionErrors) {
            reject({ modelErrors: data.DomainExecutionErrors });
          } else {
            resolve(data);
          }
        },
        response => reject(response));
    });
  }

  getActiveAirports(filter: FindFilter) {
    return new Promise<any[]>((resolve, reject) => {
      this.safeSubscribe(this._airportService.FindInDomain(filter),
        data => {
          if (data.DomainExecutionErrors) {
            reject({ modelErrors: data.DomainExecutionErrors });
          } else {
            resolve(data);
          }
        },
        response => reject(response));
    });
  }
}
